<template>
  <v-dialog ref="dateDialog" v-model="modal" :return-value.sync="date" persistent :width="dialogWidth">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field v-model="dateFormatted" :label="label" :prepend-icon="icon" :rules="rules" :color="color" readonly
        v-bind="attrs" v-on="on" clearable @click:clear="date = null" dense>
      </v-text-field>
    </template>
    <v-date-picker v-model="date" :type="type" locale="ja" :min="min" :max="max" scrollable>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="modal = false">{{ cancelBtn }}</v-btn>
      <v-btn text color="primary" @click="okHref()" :disabled="okBtnCtrl">{{ okBtn }}</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
  export default {
    name: "RyouDateFormat",
    props: {
      dialogWidth: {
        type: String,
        required: false,
        default: "290px",
      },
      label: {
        type: String,
        required: false,
        default: "日付選択",
      },
      icon: {
        type: String,
        required: false,
        default: "mdi-calendar",
      },
      color: {
        type: String,
        required: false,
        default: "",
      },
      cancelBtn: {
        type: String,
        required: false,
        default: "Cancel",
      },
      okBtn: {
        type: String,
        required: false,
        default: "OK",
      },
      value: {
        type: String,
        required: false,
        default: "",
      },
      rules: {
        type: Array,
        required: false,
        default: () => [],
      },
      type: {
        type: String,
        required: false,
        default: "month",
      },
      min: {
        type: String,
        required: false,
      },
      max: {
        type: String,
        required: false,
      },
      format: {
        type: String,
        required: false,
        default: "$1年$2月",
      },
      loadFlag: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    data() {
      return {
        modal: false,
        dateFormatted: "",
        viewDateFlag: false,
        okBtnCtrl: true
      };
    },
    created() {
      if (this.loadFlag == true) {
        this.dateFormatted = "";
      } else {
        this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10));
      }
    },
    computed: {
      date: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit("input", val);
        },
      },
    },
    watch: {
      dateFormatted(value) {
        if (value == null || value == "") {
          this.okBtnCtrl = true;
        }
        else {
          this.okBtnCtrl = false;
        }
      },
      date(value) {
        this.dateFormatted = this.formatDate(value);
      },
    },
    methods: {
      initViewDate(date) {
        this.dateFormatted = this.formatDate(date)
      },
      formatDate(date) {
        if (!date) {
          return null;
        }
        // const [year, month] = date.split('-');
        // return `${year}年${month}月`
        var reg;
        var length = date.split("-").length;
        if (length == 3) {
          reg = /(\d{4})-(\d{2})-(\d{2})/;
        } else {
          reg = /(\d{4})-(\d{2})/;
        }
        var formatDate = date.replace(reg, this.format);
        return formatDate;
      },
      okHref() {
        if (this.viewDateFlag) {
          this.$refs.dateDialog.save(this.date);

          this.$emit("ReClaimInfoGet");
        } else {
          this.$refs.dateDialog.save(this.date);
        }
        this.viewDateFlag = false;
      },
      viewDateFlagChange(value) {
        this.viewDateFlag = value;
      },
    },
  };
</script>

<style scoped>
</style>